import * as React from 'react';
import { FC } from 'react';
import styles from './Loading.module.scss';

type LoadingProps = {
    loading?: boolean
    isSuspense?: boolean
    className?: string,
    sm?: boolean,
}
export const Loading: FC<LoadingProps> = (props) => {
    const { loading, isSuspense, className, sm } = props;
    const visible = loading || isSuspense;
    const classStr = [styles.root];
    className && classStr.push(className);
    sm && classStr.push(styles.small);
    if (!visible) return null;
    return (
        <div className={classStr.join(' ')}>
            <div className={styles.spinner}>
                <div className={`${styles.crl} app-crl app-crl-1`}>
                    <svg className="app-svg" viewBox="22 22 44 44">
                        <circle className="app-crl-c" cx="44" cy="44" r="21.5" fill="none" strokeWidth="1"></circle>
                    </svg>
                </div>
                <div className={`${styles.crl} app-crl app-crl-2`}>
                    <svg className="app-svg" viewBox="22 22 44 44">
                        <circle className="app-crl-c" cx="44" cy="44" r="21.5" fill="none" strokeWidth=".8"></circle>
                    </svg>
                </div>
                <div className={`${styles.crl} app-crl app-crl-3`}>
                    <svg className="app-svg" viewBox="22 22 44 44">
                        <circle className="app-crl-c" cx="44" cy="44" r="21.5" fill="none" strokeWidth=".6"></circle>
                    </svg>
                </div>
            </div>
        </div>
    );
};